const ExamTypes = {
  ONLINE: 1, // Online
  ONLINE_2: 2, //online yêu cầu hồ sơ
  ONLINE_3: 3, //thi thử online
  OFFLINE: 0,
};

export default ExamTypes;
